"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "width", "height", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? size : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? size : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#808080' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 0.000976562C1.46957 0.000976563 0.960859 0.21169 0.585786 0.586763C0.210714 0.961836 0 1.47054 0 2.00098V5.00098C0 5.53141 0.210714 6.04012 0.585786 6.41519C0.960859 6.79026 1.46957 7.00098 2 7.00098H5C5.53043 7.00098 6.03914 6.79026 6.41421 6.41519C6.78929 6.04012 7 5.53141 7 5.00098V2.00098C7 1.47054 6.78929 0.961836 6.41421 0.586763C6.03914 0.21169 5.53043 0.000976563 5 0.000976562H2ZM2 2.00098H5V5.00098H2V2.00098ZM10 2.00098C9.73478 2.00098 9.48043 2.10633 9.29289 2.29387C9.10536 2.48141 9 2.73576 9 3.00098C9 3.26619 9.10536 3.52055 9.29289 3.70808C9.48043 3.89562 9.73478 4.00098 10 4.00098H15C15.2652 4.00098 15.5196 3.89562 15.7071 3.70808C15.8946 3.52055 16 3.26619 16 3.00098C16 2.73576 15.8946 2.48141 15.7071 2.29387C15.5196 2.10633 15.2652 2.00098 15 2.00098H10ZM10 11.001C9.73478 11.001 9.48043 11.1063 9.29289 11.2939C9.10536 11.4814 9 11.7358 9 12.001C9 12.2662 9.10536 12.5205 9.29289 12.7081C9.48043 12.8956 9.73478 13.001 10 13.001H15C15.2652 13.001 15.5196 12.8956 15.7071 12.7081C15.8946 12.5205 16 12.2662 16 12.001C16 11.7358 15.8946 11.4814 15.7071 11.2939C15.5196 11.1063 15.2652 11.001 15 11.001H10ZM0 11.001C0 10.4705 0.210714 9.96184 0.585786 9.58676C0.960859 9.21169 1.46957 9.00098 2 9.00098H5C5.53043 9.00098 6.03914 9.21169 6.41421 9.58676C6.78929 9.96184 7 10.4705 7 11.001V14.001C7 14.5314 6.78929 15.0401 6.41421 15.4152C6.03914 15.7903 5.53043 16.001 5 16.001H2C1.46957 16.001 0.960859 15.7903 0.585786 15.4152C0.210714 15.0401 0 14.5314 0 14.001V11.001ZM5 11.001H2V14.001H5V11.001Z",
    fill: fill
  }));
};

exports["default"] = _default;